import Default from "./default";
import { importHtmx } from "../helpers/sprig";

class News extends Default {
  namespace = "news";

  beforeEnter = (data) => {
    super.beforeEnter(data);
    const { next } = data;
    const scope = next.container;
    this.initJuicer(scope);
    importHtmx(next);
  };

  afterLeave = (data) => {
    super.afterLeave(data);
  };

  afterEnter = (data) => {
    super.afterEnter(data);
  };

  initJuicer = (scope) => {
    const $juicer = $(scope).find(".juicer-feed");

    if ($juicer) {
      $.getScript(`${$("base").attr("href")}/assets/js/juicer.js`);
    }
  };
}

export default new News();
